import { render, staticRenderFns } from "./TicketsInfoBirthday.vue?vue&type=template&id=51ebdbe6&scoped=true&lang=pug&"
import script from "./TicketsInfoBirthday.vue?vue&type=script&lang=js&"
export * from "./TicketsInfoBirthday.vue?vue&type=script&lang=js&"
import style0 from "./TicketsInfoBirthday.vue?vue&type=style&index=0&id=51ebdbe6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ebdbe6",
  null
  
)

export default component.exports